export const googleAnalyticsConfig = process.env.REACT_APP_GA_MEASUREMENT_ID;
export const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
export const mediaBaseUrl = process.env.REACT_APP_MEDIA_BASE_URL;
export const cubeApiUrl = process.env.REACT_APP_CUBE_API_URL;
export const hotJarId = process.env.REACT_APP_HOTJAR_ID;
